import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Rocket, Loader2, Check, CreditCard } from "lucide-react";
import api from "@/lib/api";
import { formatApiErrorDetail, euro } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { EDITIONS } from "@/lib/edition";

// Gestionale semplice → app completa: gratis con un tocco, oppure con pagamento se attivato dal gestore.
export const UpgradeCard = () => {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [offer, setOffer] = useState(null);
  const [ask, setAsk] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/company/upgrade-offer").then((r) => setOffer(r.data)).catch(() => setOffer({ payment_enabled: false })); }, []);
  const paid = !!offer?.payment_enabled;

  const upgrade = async () => {
    setBusy(true);
    try {
      if (paid) {
        const { data } = await api.post("/company/upgrade-checkout", { origin_url: window.location.origin });
        window.location.href = data.checkout_url;
        return;
      }
      await api.post("/company/upgrade");
      await refresh();
      toast.success("Fatto! Ora hai l'app completa.");
      navigate("/");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <div className="rounded-xl border-2 border-primary/30 bg-primary/5 p-5 sm:p-6 space-y-4" data-testid="upgrade-card">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-primary text-white flex items-center justify-center"><Rocket className="w-5 h-5" /></div>
        <div>
          <h3 className="font-heading font-semibold">Stai usando il Gestionale semplice</h3>
          <p className="text-xs text-muted-foreground">Passa all'app completa quando vuoi: agenda, clienti e assistente restano come sono.</p>
        </div>
      </div>
      <ul className="grid sm:grid-cols-2 gap-1.5 text-sm">
        {EDITIONS[0].features.map((f) => <li key={f} className="flex items-center gap-2"><Check className="w-4 h-4 text-emerald-600 shrink-0" />{f}</li>)}
      </ul>
      {paid && (
        <div className="text-sm" data-testid="upgrade-price">
          Costo: <b className="font-heading text-lg">{euro(offer.price)}</b> <span className="text-muted-foreground">· IVA inclusa, pagamento unico con carta</span>
        </div>
      )}
      {ask ? (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm font-medium mr-1">Confermi il passaggio all'app completa?</span>
          <Button onClick={upgrade} disabled={busy} data-testid="upgrade-confirm-button">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : paid ? <><CreditCard className="w-4 h-4 mr-2" />Paga con carta</> : "Sì, passa all'app completa"}
          </Button>
          <Button variant="ghost" onClick={() => setAsk(false)} disabled={busy} data-testid="upgrade-cancel-button">Annulla</Button>
        </div>
      ) : (
        <Button onClick={() => setAsk(true)} disabled={!offer} data-testid="upgrade-button"><Rocket className="w-4 h-4 mr-2" /> Passa all'app completa</Button>
      )}
    </div>
  );
};

export default UpgradeCard;
